

























import { Component, Prop, Vue } from "vue-property-decorator";
import { WorkshopModel, CompanyModel } from "@/core/models";
import { WorkshopService } from "@/core/services";
import {
  WorkshopDetailHeaderCpt,
  WorkshopDetailClientsGridCpt,
  WorkshopParticipantsAttendanceGridCpt,
} from "./components";
import AppVue from "@/AppVue.vue";

@Component({
  components: {
    WorkshopDetailHeaderCpt,
    WorkshopDetailClientsGridCpt,
    WorkshopParticipantsAttendanceGridCpt,
  },
})
export default class WorkshopDetailView extends AppVue {
  get workshopId() {
    return Number(this.$route.params.workshopId);
  }

  model = {} as WorkshopModel;
  loading = false;

  async created() {
    this.initializeModel();
  }

  private async initializeModel() {
    this.loading = true;
    try {
      this.model = await WorkshopService.getWorkshop(this.workshopId);
    } finally {
      this.loading = false;
    }
  }
}
